import LOGO from "./logo.png"
import test from "./image_test.png"
import test1 from "./image_test1.png"
import test2 from "./image_test2.png"
import test3 from "./image_test3.png"
import test4 from "./image_test4.png"
import liveMonitor from "./icons/Live.png"

export { LOGO, test, test1, test2, test3, test4, liveMonitor }
